import React from "react";
import _ from "underscore";

import "@/assets/textSection.css";
import { getChildrenElement } from "@/utils";

class TextSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      html: props.fields?.detailContent?.value,
    };
  }

  componentDidMount() {
    this.replaceElement();
  }

  replaceElement = () => {
    const { fields } = this.props;
    const wrapper = document.createElement("div");
    wrapper.innerHTML = fields?.detailContent?.value;

    // 判断第一个是否是文本类型
    let firstChildNodeName = wrapper.firstChild.nodeName;
    if (firstChildNodeName === "#text") {
      let firstNode = document.createElement("div");
      firstNode.innerHTML = wrapper.firstChild.nodeValue;
      // 替换第一个
      wrapper.replaceChild(firstNode, wrapper.firstChild);
    }

    const elements = getChildrenElement(wrapper);
    if (elements && elements.length > 1) {
      for (let index = 1; index < elements.length; index++) {
        const element = elements[index];
        if (element.innerHTML === "&nbsp;") {
          element.style.textDecoration = "none";
        }
      }
    }
    this.setState({ html: wrapper.innerHTML }, () => {
      // this.addHtmlTag();
    });
  };

  addHtmlTag = () => {
    const { html } = this.state;
    const splits = `<div>${html}</div>`.match(/<[^>]+[^>]*>[^<]*/g);
    let result = "";
    for (const element of splits) {
      let position = element.indexOf(">");
      let tag = element.slice(0, position + 1);
      let string = element.slice(position + 1);
      if (string && string.length > 500) {
        const list = string.match(/(.|[\r\n]){1,500}/g);
        if (list && list.length > 0) {
          let span = "<span>";
          position = tag.indexOf("style");
          if (position !== -1) {
            span = `<span ${tag.slice(position)}`;
          }
          string = _.reduce(
            _.map(list, (item) => `${span}${item}</span>`),
            (item1, item2) => item1.concat(item2)
          );
        }
      }
      tag += string;
      result += tag;
    }
    this.setState({ html: result });
  };

  render() {
    const { html } = this.state;
    return (
      <div
        className="large-18px"
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />
    );
  }
}

export default TextSection;
